import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

    set(key: string, value: any, ttl_ms = CacheDuration.OneHour) {
        const data = {value: value, expires_at: new Date().getTime() + ttl_ms / 1};
        window.localStorage.setItem(key.toString(), JSON.stringify(data));
    }

    get(key: string) {
        const data = JSON.parse(localStorage.getItem(key.toString()));
        if (data !== null) {
            if (data.expires_at !== null && data.expires_at < new Date().getTime()) {
              window.localStorage.removeItem(key.toString());
            } else {
                return data.value;
            }
        }
        return null;
    }
}

export enum CacheDuration {
  TenSeconds = 10000, // 10 seconds
  FiveMinutes = 300000, // 5 minutes
  TenMinutes = 600000, // 10 minutes
  OneHour = 3600000 // 60 minutes
}
